<template>
  <div class="general">
    <div class="general-item">
      <jContentBox2 :title="title2" :initHeaderShow='initHeaderShow' :initOptions="initOptions">
        <div class="map-box"  slot="chartBox">
          <div class="mapBag">
            <div class="legend">
              价格区间(元/亩):
              <p v-for="item,index in legendData"><span class="legend-border" :style="{'background-color':legendColors[index]}"></span>
                <span class="legend-item">{{item}}</span></p>
            </div>
            <div class="tooltip-box">
              <div class="title">月湖区</div>
              <div v-for="item,index in typeNames">{{item}}:<span class="content">{{contents[index]}}</span></div>
            </div>
          </div>
        </div>
      </jContentBox2>
    </div>
    <div class="general-item mgl-2">
      <jContentBox :title="title1">
        <div slot="boxBody">
         <table class="general-table">
           <thead>
             <tr>
               <td>价格区间(元/亩)</td>
               <td>行政区划</td>
             </tr>
           </thead>
           <tbody>
             <tr v-for="list in genData">
               <td>{{list.qj}}</td>
               <td>{{list.qh}}</td>
             </tr>
           </tbody>
         </table>
        </div>
      </jContentBox>
    </div>
  </div>
</template>

<script>
  import jContentBox from '../../components/jContentBox.vue'
  import jContentBox2 from '../../components/jContentBox2.vue'
  export default {
    name:'price',
    components:{
      jContentBox,jContentBox2
    },
    data(){
      return {
        title1: '土地流转价格分析',
        title2: '区域分布',
        initHeaderShow:false,
        initOptions:[
          {
            index: 0,
            value: '耕地'
          }, {
            index: 1,
            value: '高>低'
          }, {
            index: 2,
            value: '低>高'
          }
        ],
        legendColors:['#438aff','#43baff','#3af9db','#e2d021','#f5b634','#e98f21'],
        legendData:['<15%','15%-20%','20%-25%','25%-30%','30%-50%','>=50%'],
        genData:[
          {qj:'>=1100',qh:'月湖区'},
          {qj:'850～1100',qh:'信江新区'},
          {qj:'650～850',qh:'贵溪市'},
          {qj:'450～650',qh:'余江县'},
          {qj:'<450',qh:'--'},
          {qj:'',qh:''},
          {qj:'',qh:''},
          {qj:'',qh:''},
          {qj:'',qh:''},
        ],
        typeNames: ['平均流转价格', '同比增长率'],
        contents: ['1279（元/亩）', '3.8%'],
      }
    },
    methods: {
      tabClick(val){
        console.info(val)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .general {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .general-item {
      width: calc((100% - 20px) / 2);
      height: 100%;
      position: relative;
      .map-box {
        height: 100%;
      }
    }
  }
  .content-box2 {
    height: 100%;
    /deep/ .content-box {
      > div:nth-child(2) {
        height: calc(100% - 30px);
      }
    }
  }

  .content-box2 /deep/ .body-title{
    position: absolute;
    top:24px;
    z-index: 100;
  }
    .mapBag{
      width: 100%;
      height: calc(100% - 0px);
      background: url("../../../static/img/mapBig.jpg") no-repeat;
      background-size: 100% 100%;
      position: relative;
      .legend{
        z-index: 91;
        position: absolute;
        bottom:45px;
        right: 30px;
        height: 12px;
        font-size: 12px;
        color: #ffffff;
        margin-bottom: 110px;
      }

      .legend-item{
        display: inline-block;
        line-height: 16px;
      }
      .legend-border{
        display: inline-block;
        width: 16px;
        height: 3px;
        margin-right: 5px;
        border-radius: 1px;
        margin-bottom: 3px;
      }
    }
  .general-table{
    width: 100%;
    tr{
      border-bottom: 1px solid #29374a;
      td{
        width: 50%;
        height: 39.9px;
        line-height: 39.9px;
        text-align: center;
      }
      td:first-child{
        border-right: 1px solid #29374a;
      }
    }

    thead{
      color: #bffffb;
    }
    tbody{
      tr:last-child{
        border-bottom:none;
      }
    }
  }
  .tooltip-box {
    z-index: 91;
    display: inline-block;
    width: 180px;
    /*height: 88px;*/
    background-color: #002624;
    border: solid 1px rgba(0, 255, 238, 0.5);
    box-shadow: 1px 1px #009288;
    font-size: 12px;
    line-height: 21px;
    padding: 10px;
    border-radius: 8px;
    position: absolute;
    left: 38%;
    top: 25%;
    letter-spacing: 0px;
    color: #cccccc;

    .content {
      color: #4cd5ff;
      margin-left: 3px;
    }

    .title {
      text-align: center;
      color: #ffffff;
      margin-bottom: 5px;
    }

  }
</style>



// WEBPACK FOOTER //
// src/pages/transaction/price.vue